module.exports = __webpack_public_path__ + "static/media/housetype-blue.ec2a6b1a.svg";